<template>
  <div id="exhpredictionList">
    <div id="tableView" v-loading="this.loading" element-loading-text="加载中">
			<el-row>
        <el-form label-width="75px" :inline="true" class="el-form demo-form-inline">
          <el-row>
            <el-col :span="1">&nbsp;</el-col>
            <el-col :span="12" class="searchInline">
              <label class="el-form-item__label searchLabel">企业名称</label>
              <el-input size="small" v-model="searchForm.qymc" placeholder="企业名称" clearable></el-input>
            </el-col>
          </el-row>
          <div>
            <el-form>
              <el-col :span="12" class="btnEditDelete">
                <el-form-item align="left">
                  <el-button v-if="hasPermission('blacklist/index:add')" type="success" icon="el-icon-plus" size="small" @click="addClick('init')">新增</el-button>
                  <el-button v-if="hasPermission('blacklist/index:delete')" type="danger" icon="el-icon-delete" size="small" @click="deleteClick">删除</el-button>
                </el-form-item>
              </el-col>
              <el-col :span="12" class="btnSearchPlus">
                <el-form-item>
                  <el-button type="primary" icon="el-icon-search" size="small" @click="searchClick">查询</el-button>
                  <el-button type="clear" icon="el-icon-refresh" size="small" @click="clearClick">重置</el-button>
                </el-form-item>
              </el-col>
            </el-form>
          </div>
        </el-form>
      </el-row>
			<div class="table_container">
        <el-table class="tableStyle" border id="table" :data="tableData.slice((currentPage-1)*pageSize,currentPage*pageSize)" @selection-change="selectionChange"
          :height="tableheight" tooltip-effect="dark" :row-style="rowStyle" @cell-click="cellClick">
          <el-table-column type="selection" width="35"></el-table-column>
          <el-table-column type="index" label="序号" show-overflow-tooltip width="65" align="center"></el-table-column>
          <el-table-column prop="qymc" label="企业名称" show-overflow-tooltip min-width="25%" align="center"></el-table-column>
          <el-table-column prop="bz" label="备注" show-overflow-tooltip min-width="75%" align="center"></el-table-column>
          <el-table-column label="操作" width="75" align="center" v-if="hasPermission('blacklist/index:edit')">
            <template slot-scope="scope">
              <el-button type="text" @click="editClick(scope.row)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--翻页组件-->
        <el-row type="flex" justify="end">
          <paginator v-if="tableData.length>0"></paginator>
          <!-- <div class="buttonExport">
            <el-button type="success" icon="el-icon-download" size="small" @click="exportClick">导出</el-button>
          </div> -->
        </el-row>
			</div>

      <!-- 选择展商用户 -->
      <el-dialog title="选择企业" :visible.sync="userListVisible" :close-on-click-modal="false">
        <div v-loading="loading_user" element-loading-text="加载中">
          <el-row>
            <el-col :span="12" class="searchInline">
              <label class="el-form-item__label searchLabel" style="width:95px;">企业名称</label>
              <el-input size="small" v-model="userForm.qymc_like" placeholder="企业名称" clearable></el-input>
            </el-col>
            <el-col :span="12" style="text-align: right;">
              <el-button type="primary" icon="el-icon-search" size="small" @click="addClick('click')">查询</el-button>
              <el-button type="clear" icon="el-icon-refresh" size="small" @click="clearUserList">重置</el-button>
            </el-col>
          </el-row>
          <div class="table_container">
            <el-table border id="tableUser" :data="tableData_user.slice((currentPage_user-1)*pageSize_user,currentPage_user*pageSize_user)"
              class="tableStyle" :height="tableheight_user" @row-click="selectUser" :row-style="rowStyle">
              <el-table-column type="index" label="序号" show-overflow-tooltip width="65" align="center"></el-table-column>
              <el-table-column prop="qymc" label="企业名称" show-overflow-tooltip min-width="30%" align="center"></el-table-column>
              <el-table-column prop="sjztmc" label="数据状态" show-overflow-tooltip min-width="30%" align="center"></el-table-column>
            </el-table>
            <el-row type="flex" justify="end">
              <el-col :span="18">
                <el-pagination @current-change="currentPageChange_user" :current-page="currentPage_user" :page-size="pageSize_user" layout="total, prev, pager, next, jumper"
                  :total=parseInt(total_user)>
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-dialog>

      <!-- 行业信用等级 -->
      <el-dialog :title="title" :visible.sync="open" :close-on-click-modal="false">
        <el-form :model="form" label-width="130px" :rules="rules" ref="form">
          <el-form-item prop="qymc" label="企业名称">
            <el-input size="small" v-model="form.qymc" disabled placeholder="企业名称" clearable></el-input>
          </el-form-item>
          <el-row>
            <el-col :span="24">
              <el-form-item prop="bz" label="备注">
                <el-input type="textarea" :autosize="{minRows:3}" maxlength="200" size="small" v-model="form.bz" placeholder="备注" clearable></el-input>
              </el-form-item>
              <el-row style="margin-top: -15px;margin-bottom: 15px;text-align:right">
                <div class="el-upload__tip">最大可输入<font style="color:red">{{ 200 }}</font>个字，还可输入
                  <span style="color: red" id="cgmsLength">{{200-(form.bz != null ? form.bz.length : 0) >= 0 ? 200-(form.bz != null ? form.bz.length : 0) : 0}}</span>个字
                </div>
              </el-row>
            </el-col>
          </el-row>
        </el-form>
        <el-row class="buttonSubmit">
          <el-button type="clear" icon="el-icon-close" size="small" class="btn_submit" @click="closeDialog()">取消</el-button>
          <el-button type="success" icon="el-icon-check" size="small" @click="save">保存</el-button>
        </el-row>
      </el-dialog>
		</div>
  </div>
</template>
<script>
//引入翻页 paginator
import paginator from '@/components/paginator'
export default {
  components: {
    paginator
  },
  data() {
    return {
      //当前登陆用户
      currentUser: this.CONSTANT.currentUser,
      //搜索表单
      searchForm: {
        qymc: "",
        hyxydj: ""
      },
      exportForm: [],
      tableData: [],
      //表高度变量
      tableheight: this.CONSTANT.tableheight10,
      imgViewVisible: false,
      //多选值
      multipleSelection: [],
      //显示加载中样
      loading: false,
      //当前页
      currentPage: 1,
      //分页大小
      pageSize: 10,
      //总记录数
      total: 0,
      //用户dialog
      userForm: {
        qymc_like: ''
      },
      tableData_user: [],
      userListVisible: false,
      tableheight_user: 251,
      //显示加载中样
      loading_user: false,
      //当前页
      currentPage_user: 1,
      //分页大小
      pageSize_user: 5,
      //总记录数
      total_user: 0,
      // 导入设置headers
      headers: {"Content-Type": "multipart/form-data;charset=UTF-8", XTOKEN: localStorage.getItem("XTOKEN")},
      // 新增信用等级form
      form: {
        qyid: "",
        qymc: "",
        bz: ""
      },
      rules: {
        
      },
      open: false,
      title: "",
    };
  },
  created: function() {
    if(this.$store.state.listPagePars.has(this.$route.path)){
        this.searchForm = this.$store.state.listPagePars.get(this.$route.path);
        this.currentPage = this.searchForm.pageNum;
        this.pageSize = this.searchForm.pageSize;
      }
    this.searchClick('page');
  },
  methods: {
    //表格查询事件
    searchClick: function(type) {
      let vm = this;
      this.tableData = [];
      if (type != 'page') {
        this.currentPage = 1;
      }
      vm.loading = true;//表格重新加载
      var params = {
        qymc_like: vm.searchForm.qymc.replace(/%/g, "\\%"),
        pageSize: vm.pageSize,
        pageNum: vm.currentPage
      }
      vm.$axios.post('/cfpahmd/page', params).then(function (res) {
        var tableTemp = new Array((vm.currentPage-1)*vm.pageSize);
        vm.tableData = tableTemp.concat(res.data.result.list);
        this.total = res.data.result.total;
        this.exportForm = [this.searchForm.gsmc, this.searchForm.sjzt, this.searchForm.shzt];
        this.loading = false;

        this.$store.dispatch('saveListPagePars', {path: this.$route.path, pars: params});
      }.bind(this), function (error) {
        console.log(error)
      })
    },

    //清空查询条件
    clearClick: function() {
      this.searchForm.qymc = '';
      this.searchClick('reset');
    },

    //表格勾选事件
    selectionChange: function(val) {
      this.multipleSelection = val;
    },

    //新增事件
    addClick: function(type) {
      let vm = this;
      vm.tableData_user = [];
      if (type == 'init') {
        vm.userForm.qymc_like = '';
      }
      if (type != 'page') {
        vm.currentPage_user = 1;
      }
      vm.loading_user = true;
      var params = {
        qymc_like: vm.userForm.qymc_like.replace(/%/g, "\\%"),
        pageSize: vm.pageSize_user,
        pageNum: vm.currentPage_user
      };
      vm.$axios.post('/qyjbxx/selectQyxxHmd', params).then(function (res) {
        var tableTemp = new Array((vm.currentPage_user - 1) * vm.pageSize_user);
        vm.tableData_user = tableTemp.concat(res.data.result.list);
        vm.total_user = res.data.result.total;
        vm.userListVisible = true;
        vm.loading_user = false;
      }.bind(this), function (error) {
        console.log(error);
      })
    },

    //表格修改事件
    editClick: function(val, index) {
      this.$axios.get("cfpahmd/" + val.uuid).then(res => {
        if (res.data.code == "00000000") {
          this.form = res.data.result
          this.title = "编辑黑名单"
          this.open = true
        }
      })
    },

    //删除所选，批量删除
    deleteClick: function() {
      this.$confirm('确定删除已选中黑名单信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let vm = this;
        for (var i in this.multipleSelection) {
          vm.multipleSelection[i].xgrid = this.currentUser.userid;
          vm.multipleSelection[i].xgrmc = this.currentUser.username;
          vm.multipleSelection[i].deleteFlag = 'Y';
        }
        vm.$axios.post('/cfpahmd/doDeleteHmdList', vm.multipleSelection).then(function (res) {
          vm.$message({
            message: "成功删除" + res.data.result + "条黑名单信息",
            showClose: true,
            onClose: this.searchClick('delete')
          });
        }.bind(this), function (error) {
          console.log(error)
        })
      }).catch(() => {
        vm.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },

    //查询展商信息
    selectUser: function (val) {
      if (val.hmd == null || val.hmd == "") {
        this.userListVisible = false;
        if (this.form.uuid) delete this.form.uuid
        this.form.qyid = val.qyid
        this.form.qymc = val.qymc
        this.form.bz = ""
        this.title = "新增黑名单"
        this.open = true
        console.log(this.form);
      } else {
        this.$message.warning("选中的企业已经在黑名单中")
      }
    },

    //用户弹出页翻页
    currentPageChange_user: function (val) {
      if (this.currentPage_user != val) {
        this.currentPage_user = val;
        this.addClick('page');
      }
    },

    //清除用户列表
    clearUserList: function () {
      this.userForm.qymc_like = '';
      this.addClick('reset');
    },

    //关闭Dialog
    closeDialog: function() {
      this.$refs["form"].resetFields();
      this.searchClick('page');
      this.open = false;
    },
    // 保存
    save () {
      this.$refs["form"].validate((valid) => {
        if(valid) {
          if (!this.form.uuid) {
            this.form.cjrid = this.currentUser.userid;
            this.form.cjrmc = this.currentUser.username;
            this.$axios.post("cfpahmd", this.form).then(res => {
              if (res.data.code == "00000000") {
                this.$message.success("新增成功")
                this.open = false
                this.searchClick("add")
              } else {
                this.$message.error(res.data.msg)
              }
            }).catch(err => {
              this.$message.error("新增失败")
            })
          } else {
            this.form.xgrid = this.currentUser.userid;
            this.form.xgrmc = this.currentUser.username;
            this.$axios.put("/cfpahmd", this.form).then(res => {
              if (res.data.code == "00000000") {
                this.$message.success("编辑成功")
                this.open = false
                this.searchClick("page")
              } else {
                this.$message.error(res.data.msg)
              }
            }).catch(err => {
              this.$message.error("编辑失败")
            })
          }
        }
      })
    },
    //导出
    // exportClick: function () {
    //   window.open(window.config.domain + "/qyjbxx/doExportJbxx/" + this.exportForm);
    // },
    // //add by yushch 20200323 解决企业名称为空时不能点击详情页bug
    cellClick: function(row, column, cell, event){
      if(column.label == "企业名称"){
        // this.$router.push({name:"exhpredictionDetail", query: {id: row.qyid, type: 'search'}});
      }
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/views/exhibition/prediction/blacklist/index.vue